import { useCurrentProvider } from '../../Components/Permissions';
import { Flag } from '../../featureFlags';

/**
 * Whether the MCP Utilization tab should render the Hex utilization dashboard
 * in place of the built-in sessions dashboard (PDE-1319).
 *
 * Requires the feature flag plus the same entitlement prerequisites the API
 * enforces: Sessions Model AND "Show Utilization Tab to MCP Admin"
 * (captured by `showProviderUtilizationTab()` when sessions are used), and
 * excludes DGM orgs, which keep the existing in-built UI (AC #1/#3).
 */
export const useShowUtilizationHexDashboard = (): boolean => {
  const {
    featureFlags,
    usesSessions,
    providerOrgUsesDedicatedGroupModel,
    showProviderUtilizationTab,
  } = useCurrentProvider();

  return (
    featureFlags.includes(Flag.UtilizationHexDashboardsEnabled) &&
    Boolean(usesSessions()) &&
    showProviderUtilizationTab() &&
    !providerOrgUsesDedicatedGroupModel()
  );
};
